import { RCS } from "@/utils/ConstantRouter";
import { AxiosClient } from "../../utils/axios";
import { logError } from "../../utils/logError";
export const state = () => ({
  school_detail: {},
  school_address: [],
  school_staffs: [],
  school_infra: [],
  school_links: [],
  school_others: [],
  school_outstanding: {},
  loading: true,
});

export const mutations = {
  SCHOOL_DETAIL(state, payload) {
    state.school_detail = payload;
  },
  SCHOOL_ADDRESS(state, payload) {
    state.school_address = payload;
  },
  SCHOOL_STAFFS(state, payload) {
    state.school_staffs = payload;
  },
  SCHOOL_INFRASTRUCTURE(state, payload) {
    state.school_infra = payload;
  },
  SCHOOL_LINKS(state, payload) {
    state.school_links = payload;
  },
  SCHOOL_OTHER(state, payload) {
    state.school_others = payload;
  },
  SCHOOL_OUTSTANDING(state, payload) {
    state.school_outstanding = payload;
  },
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
};

export const actions = {
  async getSchoolDetail({ commit, rootState }, id) {
    try {
      const doamain = process.env.BASE_URL_CLIENT;
      const isOnServer = process.server;
      //   let res;
      //   if (isOnServer) {
      //     res = await AxiosClientServerNuxt.get(
      //       `/api${RCS.SCHOOL_DETAIL}?id=${id}`,
      //       {}
      //     );
      //   } else {
      //     res = await AxiosClient.get(
      //       `${doamain}/api${RCS.SCHOOL_DETAIL}?id=${id}`,
      //       {}
      //     );
      //   }
      //   console.log("Line 56", res);
      const res = await AxiosClient.get(
        `/eduzone/api${RCS.SCHOOL_DETAIL}?id=${id}`,
        {}
      );
      if (Object.keys(res.data?.data).length == 0) {
        return {
          success: true,
          data: {},
        };
      }
      commit("SCHOOL_DETAIL", res.data?.data);

      commit("SCHOOL_ADDRESS", res?.data?.data.address);
      commit("SCHOOL_INFRASTRUCTURE", res?.data?.data.infrastructure);
    } catch (error) {
      logError(error, "getSchoolDetail on store");
    }
  },
  // async getSchoolAddress({ commit }, id) {

  //     try {
  //         const res = await AxiosClient.get(`/api${RCS.SCHOOL_ADDRESS}?id=${id}`)
  //         commit("SCHOOL_ADDRESS", res?.data?.data)
  //     } catch (err) {
  //         return console.log({ getSchoolAddressVuex: err })
  //     }
  // },
  async getSchoolStaffs({ commit, rootState }, id) {
    try {
      const res = await AxiosClient.get(
        `/eduzone/api${RCS.SCHOOL_STAFFS}?id=${id}`,
        {}
      );
      commit("SCHOOL_STAFFS", res?.data?.data);
    } catch (error) {
      logError(error, "getSchoolStaffs error");
    }
  },
  // async getSchoolInfraStructure({ commit }, id) {

  //     const res = await AxiosClient.get(`/api${RCS.SCHOOL_INFRASTRUCTURE}?id=${id}`)
  //     commit("SCHOOL_INFRASTRUCTURE", res?.data?.data)
  // },
  async getSchoolLinks({ commit, rootState }, id) {
    try {
      const res = await AxiosClient.get(`/eduzone/api${RCS.SCHOOL_LINKS}?id=${id}`, {});
      commit("SCHOOL_LINKS", res?.data?.data);
    } catch (error) {
      logError(error, "getSchoolLinks on store");
    }
  },
  async getSchoolOther({ commit, rootState }, page_size) {
    try {
      const res = await AxiosClient.get(
        `/eduzone/api${RCS.SCHOOL_OTHER}?page_size=${page_size}`,
        {}
      );
      commit("SCHOOL_OTHER", res?.data?.data);
    } catch (error) {
      logError(error, "getSchoolOther on store");
    }
  },
  async getSchoolOutstanding({ commit, rootState }, school_id) {
    try {
      const res = await AxiosClient.get(
        `/eduzone/api${RCS.SCHOOL_OUTSTANDING}?school_id=${school_id}`,
        {}
      );
      if (res.data && res.data.data && res.data.data[0]) {
        const convertToObj = res.data.data[0];
        commit("SCHOOL_OUTSTANDING", convertToObj);
      }
    } catch (error) {
      logError(error, "getSchoolOutstanding on store");
    }
  },
};
